<span class="chip" [attr.data-count]="chip.count" [attr.data-status]="chip.status" (click)="onClick()">
    <ng-content></ng-content> {{chip.label}}
</span>